import { Controller } from "stimulus";
import dispatchCustomEvent from "../functions/dispatchCustomEvent.js";

// Dispatches `data-event-name` without a query string, so a target loaded with
// `load_html(remember_query: true)` reloads with the query it last loaded (its filter and page),
// then each event named in `data-interval-reload-extra-events` (space separated).
//
// With `data-interval-reload-seconds` set, that dispatch also runs on a timer while the tab is
// visible. Without it there is no timer and `refresh()` is the only trigger.
export default class extends Controller {
  connect() {
    if (this.seconds > 0) {
      this.timer = setInterval(() => this.tick(), this.seconds * 1000);
    }
  }

  disconnect() {
    clearInterval(this.timer);
  }

  tick() {
    if (document.visibilityState !== "visible") {
      return;
    }

    // An open dialog confirms an action on a row in the reloaded target (e.g. delete/retry), so
    // the rows stay as the user saw them until it closes.
    if (document.querySelector("dialog[open]")) {
      return;
    }

    this.dispatchReload({ silent: true });
  }

  refresh() {
    this.dispatchReload();
  }

  // Named to avoid shadowing Stimulus's own `Controller#dispatch` helper.
  dispatchReload(detail = {}) {
    dispatchCustomEvent(document, this.eventName, true, true, detail);

    this.extraEvents.forEach((eventName) => dispatchCustomEvent(document, eventName));
  }

  get eventName() {
    return this.element.dataset.eventName;
  }

  get seconds() {
    return Number(this.element.dataset.intervalReloadSeconds) || 0;
  }

  get extraEvents() {
    return (this.element.dataset.intervalReloadExtraEvents || "").split(" ").filter(Boolean);
  }
}
